import { styled, Typography } from '@mui/material';
export const StyledTypography = styled(Typography)(({ theme }) => ({
    paddingTop: '10px',
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '1.3rem',
    [theme.breakpoints.down('sm')]: {
        fontSize: '1rem',
    },
}));
